import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  connectAuthEmulator
} from 'firebase/auth';
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { Capacitor } from '@capacitor/core';

// Firebase web config for project headtohead-ac5c4 (public client config).
const firebaseConfig = {
  apiKey: 'AIzaSyCxJ36dyye0aOlHjf1a_ScyND8rAccRRUE',
  authDomain: 'headtohead-ac5c4.firebaseapp.com',
  projectId: 'headtohead-ac5c4',
  storageBucket: 'headtohead-ac5c4.firebasestorage.app',
  messagingSenderId: '608696855626',
  appId: '1:608696855626:web:797475f536e231e8b08ab3',
  measurementId: 'G-S01MGHHG0E'
};

export const app = initializeApp(firebaseConfig);

// Native (Capacitor) requires IndexedDB persistence; web uses local storage.
export const auth = initializeAuth(app, {
  persistence: Capacitor.isNativePlatform()
    ? indexedDBLocalPersistence
    : browserLocalPersistence
});

// In dev, talk to the local emulator suite by default (disable with VITE_USE_EMULATOR=0).
const useEmulator =
  import.meta.env.VITE_USE_EMULATOR === '1' ||
  (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATOR !== '0');

export const usingEmulator = useEmulator;

// Production lives in the named "headtoheadeurope" database. The Firestore
// emulator doesn't support named databases (or rules on them), so in dev we use
// the default database — which is also the only one the rules emulator enforces.
//
// Inside the native WKWebView the auto-detect long-polling probe is unreliable:
// one-shot getDoc reads work, but getDocs queries (e.g. the username lookup on
// the profile step) can hang forever. Forcing long-polling on native makes the
// query channel deterministic; the browser keeps fast auto-detect.
const firestoreSettings = Capacitor.isNativePlatform()
  ? { experimentalForceLongPolling: true }
  : { experimentalAutoDetectLongPolling: true };

export const db = useEmulator
  ? initializeFirestore(app, firestoreSettings)
  : initializeFirestore(app, firestoreSettings, 'headtoheadeurope');

export const storage = getStorage(app);

// Callable Cloud Functions live in us-central1 (see functions/src/jobs/*).
export const functions = getFunctions(app, 'us-central1');

if (useEmulator) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  // eslint-disable-next-line no-console
  console.info('[firebase] Using local emulators (auth:9099, firestore:8080, functions:5001, storage:9199, db:(default)).');
}

export default app;
